module.exports = __webpack_public_path__ + "static/media/Bar_Cocktails-left.5c1c4f00.jpg";